import { Injectable } from '@nestjs/common';
import { BroadcastSummaryModel, BroadcastSummaryResponse, ErrorResponse, GlobalResponseObject, MessageBroadcastStatusEnum, MessageTypeEnum, PriorityEnum } from '@schemax-whatsapp/shared-models';
import { BiMessageRepository } from '../entity/repository/bi-message.repository';
import { MessageRequest } from './dto/message.request';
import { appConfig } from '../../../config';
import { BiMessage } from '../entity/bi-message.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { BroadcastMessageRequest } from './dto/broadcast-message.request';
import { BroadcastMessage } from './entity/broadcast-message.entity';
import { BroadcastContact } from './entity/broadcast-contact.entity';
import { BMIdRequest } from './dto/bm-id.request';
import { CompanyIdDateRangeRequest } from './dto/company-id-date-range.request';

@Injectable()
export class BroadcastInfoService {

    constructor(
        @InjectRepository(BiMessage) private biMsgRepo: Repository<BiMessage>,
        @InjectRepository(BroadcastMessage) private bmRepo: Repository<BroadcastMessage>,
        @InjectRepository(BroadcastContact) private bcRepo: Repository<BroadcastContact>
    ) {

    }

    /**
     * 
     * @param companyIdReq 
     * @returns 
     */
    async getBroadCastSummaryStatusForCompany(companyIdReq: CompanyIdDateRangeRequest): Promise<BroadcastSummaryResponse> {
        const summary: BroadcastSummaryModel[] = [];
        let broadcastInfo: BroadcastMessage[] = [];
        if(companyIdReq.fromDate) {
            broadcastInfo = await this.bmRepo.find({ where: { companyId: companyIdReq.companyId, createdAt: Raw(()=>` DATE(created_at) >= '${companyIdReq.fromDate}' AND DATE(created_at) <= '${companyIdReq.toDate}' `) }});
        } else {
            broadcastInfo = await this.bmRepo.find({ where: { companyId: companyIdReq.companyId }});
        }
        if(broadcastInfo.length == 0) {
            throw new ErrorResponse(0, 'No Broadcasts found for the selected criteria');
        }
        for(const bm of broadcastInfo) {
            // get the total count of msgs that were not sent 
            const progressCount = await this.bcRepo.count({ where: {bmId: bm.id, status: MessageBroadcastStatusEnum.PENDING}});
            const failedCount = 0;
            summary.push(new BroadcastSummaryModel(bm.templateName, bm.id, Number(bm.totalMsgCount), bm.totalMsgCount-progressCount, failedCount, progressCount, bm.createdAt.toString()));
        }
        return new BroadcastSummaryResponse(true, 0, 'Broadcast summary retrieved successfully', summary);
    }


}